// Don't use pre-defined names like Element. IE8 will impose restrictions like
// not allowing redefining certain methods (Element.create)
ObjectUtils.define('DOM', {

  enableDebug: 0,

  findById: function findById(id) {
    var elem = this.maybeFindById(id);
    if (!elem) {
      var errorMessage = 'Failed to locate element';
      var data = {};
      if (!id || (typeof id === 'string')) {
        data.id = id || '<null>';
      }
      ErrorManager.logError('Failed to locate element', data);
    }
    return elem;
  },

  exists: function exists(id) {
    return this.maybeFindById(id) ? true : false;
  },

  maybeFindById: function maybeFindById(id) {
    if (!id || id === undefined) {
      return null;
    }

    if (typeof id === 'string') {
      var list = this.findAllBySelector('#' + id);

      if (list.length === 0) {
        return null;
      }

      id = list.first();
    }

    return this._wrapElement(id);
  },

  _wrapElement: function _wrapElement(id) {
    if ('__isObject' in id) {
      return id;
    }

    // Certain jquery operations are called directly in code. E.g. parent()
    // They return jquery objects without the __isObject key.
    if (id instanceof Vendor.jQuery) {
      id.__isObject = 1;
      return id;
    }

    var object = Vendor.jQuery(id);
    object.__isObject = 1;
    return object;
  },

  maybeFindByTag: function maybeFindByTag(element, tagName) {
    return this.maybeFindBySelector(element, tagName);
  },

  findByTag: function findByTag(element, tagName) {
    return this.findBySelector(element, tagName);
  },

  maybeFindByClass: function maybeFindByClass(element, className) {
    return this.maybeFindBySelector(element, '.'+className);
  },

  findByClass: function findByClass(element, className) {
    return this.findBySelector(element, '.'+className);
  },

  maybeFindByName: function maybeFindByName(element, name) {
    return this.maybeFindBySelector(element, '[name="'+name+'"]');
  },

  findByName: function findByName(element, name) {
    return Assert.TRUTHY(this.maybeFindByName(element, name), 'Failed to locate element by name ['+name+']');
  },

  findAllByClass: function findAllByClass(element, className) {
    return this.findAllBySelector(element, '.'+className);
  },

  maybeFindBySelector: function maybeFindBySelector(element, selector) {
    var result = this.findAllBySelector.apply(this, arguments);
    return result.length ? result.first() : null;
  },

  findByXpath: function findByXpath(query) {
    var elem = document.evaluate(query, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

    if (!elem) {
      Assert.FAIL('Failed to locate element with xpath ['+query+']');
      return null;
    }

    return DOM.findById(elem);
  },

  findBySelector: function findBySelector() {
    var result = this.maybeFindBySelector.apply(this, arguments);
    if (result) {
      return result;
    }

    var selector = arguments.length === 2 ? arguments[1] : arguments[0];
    Assert.FAIL('Failed to locate element with selector ['+selector+']');
  },

  findAllBySelector: function findAllBySelector() {
    if (arguments.length === 2) {
      var element = arguments[0];
      var selector = arguments[1];
      return this.findById(element).find(selector);
    }

    return Vendor.jQuery(arguments[0]);
  },

  firstChild: function firstChild(elem) {
    return this.findById(elem).children().first();
  },

  id: function id(elem) {
    return this.getAttribute(elem, 'id');
  },

  getRequiredAttribute: function getRequiredAttribute(elem, attributeName) {
    var value = this.findById(elem).attr(attributeName);

    if (ObjectUtils.isUndefined(value)) {
      Assert.FAIL('[DOM] Expected non-empty value for attribute', {
        attribute: attributeName,
      });
    }

    return value;
  },

  getAttribute: function getAttribute(elem, attributeName, defaultValue) {
    // Doesn't seem like this is necessary. Attribute lookups appear to be case insensitive.
    // attributeName = attributeName.toLowerCase();
    var value = this.findById(elem).attr(attributeName);
    if (ObjectUtils.isUndefined(value)) {
      return defaultValue;
    }
    return value;
  },

  removeAttribute: function removeAttribute(elem, attributeName) {
    return this.findById(elem).removeAttr(attributeName);
  },

  setAttribute: function setAttribute(elem, attributeName, value) {
    this.findById(elem).attr(attributeName, value);
  },

  getData: function getData(elem, attributeName) {
    return this.getAttribute(elem, attributeName);
  },

  setData: function setData(elem, attributeName, value) {
    return this.setAttribute(elem, attributeName, value);
  },

  tagName: function tagName(node) {
    if (this.isEqualTo(node, document)) {
      return 'document';
    } 
    // Avoid using 'tagName' because forms with an input named 'tagName' will
    // return that input instead of the element's HTML tag.
    // nodeName is same as tagName except it works for text/comment nodes also.
    return this.findById(node).prop('nodeName').toLowerCase();
  },

  maybeFindParentButton: function maybeFindParentButton(node) {
    return this.maybeFindParentByClass(node, 'UILegacyButton') || this.maybeFindParentByClass(node, 'UIButton');
  },

  getInputValue: function getInputValue(container, inputName) {
    var input = DOM.findInput(container, inputName);
    return input.val();
  },

  setInputValue: function setInputValue(container, inputName, value) {
    var input = DOM.findInput(container, inputName);
    return input.val(value);
  },

  findInput: function findInput(container, inputName) {
    return Assert.TRUTHY(this.maybeFindInput(container, inputName), 'Failed to locate input with name ['+inputName+']');
  },

  maybeFindInput: function maybeFindInput(form, inputName) {
    var that = this;
    var inputs = DOM.findAllBySelector(form, '*[name="'+inputName+'"]').filter(function() {
      // This can match div for custom UI elements like dropdowns and period pickers.
      // https://api.jquery.com/input-selector/
      var tagName = that.tagName(this);
      return (
        tagName === 'input'
        || tagName === 'textarea'
        || tagName === 'select'
      );
    });

    if (!inputs.length) {
      return null;
    }

    // Don't use ArrayUtils or array offsets here, because all jQuery objects are arrays
    var firstInput = inputs.first();
    firstInput =  this._wrapElement(firstInput);

    if (inputs.length === 1) {
      return firstInput;
    }

    var inputType = DOM.getAttribute(firstInput, 'type');
    if (inputType === 'radio') {
      var selectedRadio;
      inputs.each(function(key, input) {
        if (input.checked) {
          selectedRadio = input;
          return false;
        }
      });

      if (selectedRadio) {
        return this._wrapElement(selectedRadio);
      }
    }

    return firstInput;
  },

  isSubmitButton: function isSubmitButton(elem) {
    return (this.tagName(elem) == 'input' && this.getAttribute(elem, 'type') == 'submit') 
    || (this.hasClass(elem, 'UILegacyButton') && this.hasClass(elem, 'submitButton'))
    || (this.hasClass(elem, 'UIButton') && this.getAttribute(elem, 'type') === 'submit');
  },

  isButton: function isButton(elem) {
    return (this.tagName(elem) == 'input' && this.getAttribute(elem, 'type') == 'submit') 
    || (this.tagName(elem) == 'input' && this.getAttribute(elem, 'type') == 'button') 
    || this.hasClass(elem, 'UILegacyButton')
    || this.hasClass(elem, 'UIButton');
  },

  nodeType: function nodeType(node) {
    return this.findById(node).prop('nodeType');
  },

  setValue: function setValue(elem, value) {
    this.findById(elem).val(value);
  },

  getValue: function getValue(elem) {
    return this.findById(elem).val();
  },

  value: function value(elem) {
    return this.getValue(elem);
  },

  focus: function focus(elem, offset) {
    elem = this.findById(elem);
    var inputValue = elem.val();
    elem.trigger('focus');
    elem.val('');
    elem.val(inputValue);

    if (!offset) {
      return;
    }

    var inputField = elem[0];
    var widthSoFar = 0;
    for (var i = 0; i < inputValue.length; ++i) {
      var c = inputValue[i];
      widthSoFar += this.getWidthForText(c);

      if (widthSoFar >= offset) {
        inputField.selectionStart = i-1;
        inputField.selectionEnd = i-1;
        break;
      }
    }
  },

  isEqualTo: function isEqualTo(elem1, elem2) {
    elem1 = this.findById(elem1);
    elem2 = this.findById(elem2);
    if (elem1.is(elem2)) {
      return true;
    }
    if (this.getAttribute(elem1, 'id')) {
      return this.getAttribute(elem1, 'id') == this.getAttribute(elem2, 'id');
    }
    var randomId = StringUtils.generateId();
    this.setAttribute(elem1, 'uniqid', randomId);
    var isEqual = this.getAttribute(elem1, 'uniqid') == this.getAttribute(elem2, 'uniqid');
    this.removeAttribute(elem1, 'uniqid');
    return isEqual;
  },

  isParent: function isParent(elem, parentToTest) {
    var isParent = false;
    var that = this;
    this.maybeFindParent(elem, function(node) {
      if (that.isEqualTo(node, parentToTest)) {
        isParent = true;
        return false;
      }
    });
    return isParent;
  },

  findParent: function findParent(elem, selectorFunction) {
    return Assert.TRUTHY(
      this.maybeFindParent(elem, selectorFunction),
      'Failed to locate parent with specified selector'
    );
  },

  maybeFindParent: function maybeFindParent(elem, selectorFunction) {
    elem = this.findById(elem);
    while (elem && elem.length > 0 && (this.nodeType(elem) != 1 || !selectorFunction(elem))) {
      elem = elem.parent();
    }
    return elem.length ? elem.first() : null;
  },

  findParentByClass: function findParentByClass(elem, className) {
    var elemParent = this.maybeFindParentByClass(elem, className);
    if (!elemParent) {
      ErrorManager.logError('Failed to locate parent with class name ['+className+']');
    }
    return elemParent;
  },

  maybeFindParentByClass: function maybeFindParentByClass(elem, className) {
    return this.maybeFindParentBySelector(elem, '.'+className);
  },

  maybeFindParentByTag: function maybeFindParentByTag(elem, tag) {
    return this.maybeFindParentBySelector(elem, tag.toLowerCase());
  },

  maybeFindParentBySelector: function maybeFindParentBySelector(elem, selector) {
    var that = this;
    return this.maybeFindParent(elem, function(node) {
      return node.is(selector);
    });
  },

  findParentBySelector: function findParentBySelector(elem, selector) {
    return Assert.TRUTHY(this.maybeFindParentBySelector(elem, selector), 'Failed to locate parent with selector', {
      selector: selector,
    });
  },

  findParentByTag: function findParentByTag(elem, tag) {
    return Assert.TRUTHY(this.maybeFindParentByTag(elem, tag), 'Failed to locate parent with tag', {
      tag: tag,
    });
  },

  shouldSubmitOnEnter: function shouldSubmitOnEnter(node) {
    return this.tagName(node) == 'input' || this.maybeFindParentByClass(node, 'UIControl');
  },

  isAmountInput: function isAmountInput(elem) {
    return (
      this.isTextField(elem)
      && (
        this.hasClass(elem, 'amount')
        || this.hasClass(elem, 'amountInput')
      )
    );
  },
 
  isTextField: function isTextField(elem) {
    var tagName = this.tagName(elem);
    if (tagName === 'textarea') {
      return true;
    }

    if (tagName !== 'input') {
      return false;
    }

    var textInputTypes = {
      text: 1,
      email: 1,
      tel: 1,
      amount: 1,
      number: 1
    };
    return (this.getAttribute(elem, 'type', '') in textInputTypes);
  },

  size: function size(elem) {
    return {
      width: this.width(elem),
      height: this.height(elem)
    };
  },

  fontSize: function fontSize(elem) {
    return this.getStyle(elem, 'font-size').replace(/px$/, '');
  },

  width: function width(elem) {
    return this.findById(elem).outerWidth();
    // This width doesn't include padding.
    // return parseInt(this.getStyle(elem, 'width'));
  },

  height: function height(elem) {
    // outerHeight(true) will include `margin` as well.
    return this.findById(elem).outerHeight();
    // This width doesn't include padding.
    // return parseInt(this.getStyle(elem, 'height'));
  },

  setWidth: function setWidth(elem, width) {
    // jquery's `elem.width(w)` will set content width, not including margins
    this.setStyle(elem, 'width', width);
  },

  setHeight: function setHeight(elem, height) {
    return this.findById(elem).css('height', height);
  },

  maxHeight: function maxHeight(elem) {
    return parseInt(this.getStyle(elem, 'max-height'));
  },

  fromContent: function fromContent(content) {
    // Using DOM APIs is much faster.
    // var startTime = DateUtils.currentTimeInMilliseconds();
    var div = document.createElement('div');
    div.innerHTML = content;
    var el = div.childNodes[0];
    el = Vendor.jQuery(el);
    // var el = Vendor.jQuery(content);
    el.__isObject = 1;
    return el;
  },

  createElement: function createElement(tag) {
    return Vendor.jQuery('<'+tag+'></'+tag+'>');
  },

  setStyle: function setStyle(element, style, value) {
    var properties = {};

    if (ObjectUtils.isUndefined(value)) {
      properties = style;
    } else {
      properties[style] = value;
    }

    var transforms = {};
    var styles = {};
    var numTransforms = 0;
    var numStyles = 0;
    ArrayUtils.each(properties, function(propertyName, value) {
      if (propertyName == 'translateX' || propertyName == 'translateY' || propertyName == 'scale' || propertyName == 'rotate') {
        transforms[propertyName] = value;
        ++numTransforms;
      } else {
        styles[propertyName] = value;
        ++numStyles;
      }
    });
    if (numTransforms) {
      this.setTransforms(element, transforms);
    }
    if (numStyles) {
      element.css(styles);
    }
  },

  getStyle: function getStyle(element, style) {
    return this.findById(element).css(style);
  },

  visible: function visible(element) { 
    return this.isVisible(element);
  },

  isVisible: function isVisible(elem) {
    return this.findById(elem).is(':visible');
  },

  isHidden: function isHidden(element) { 
    return this.findById(element).is(":hidden");
  },

  setVisible: function setVisible(elem, isVisible) {
    return this.findById(elem).css('visibility', isVisible ? 'visible' : 'hidden');
  },

  toggle: function toggle() {
    var that = this;
    Vendor.jQuery.each(arguments, function(k, e) {
      that.findById(e).toggle();
    });
  },

  showIf: function showIf(elem, condition) {
    if (condition) {
      this.show(elem);
    } else {
      this.hide(elem);
    }
  },

  show: function show(elem) {
    return this.findById(elem).show();
  },

  showAll: function hideAll(elems) {
    ArrayUtils.each(elems, function(index, elem) {
      DOM.show(elem);
    });
  },

  hideAll: function hideAll(elems) {
    ArrayUtils.each(elems, function(index, elem) {
      DOM.hide(elem);
    });
  },

  hide: function hide(elem) {
    return this.findById(elem).hide();
  },

  blur: function blur(elem) {
    return this.findById(elem).blur();
  },

  getActiveElement: function getActiveElement() {
    return this.findById(document.activeElement);
  },

  addClassIf: function addClassIf(element, className, condition, secondClassName) {
    if (condition) {
      this.addClass(element, className);
      secondClassName && this.removeClass(element, secondClassName);
    } else {
      this.removeClass(element, className);
      secondClassName && this.addClass(element, secondClassName);
    }
  },

  toggleClass: function toggleClass(element, className, secondClassName) {
    this.addClassIf(element, className, !this.hasClass(element, className), secondClassName);
  },

  addClass: function addClass(element, className) {
    return this.findById(element).addClass(className);
  },

  removeClass: function removeClass(element, className) {
    return this.findById(element).removeClass(className);
  },

  hasClass: function hasClass(element, className) {
    return this.findById(element).hasClass(className);
  },

  innerHtml: function innerHtml(element) {
    return this.findById(element).html().trim();
  },

  setInnerHtml: function setInnerHtml(element, html) {
    element = this.findById(element);
    element.html(html);
    this.removeAttribute(element, 'loadingsetup');

    return element;
  },

  appear: function appear(elem) {
    this.findById(elem).slideDown();
  },

  fadeInto: function fadeInto(elem1, elem2, options) {
    elem1 = this.findById(elem1);
    elem2 = this.findById(elem2);
    options = options || { };

    elem1.fadeOut(500);
    if (options.onHide) {
      setTimeout(options.onHide, 500);
    }

    setTimeout(function() {
      elem2.fadeIn(1000);
    }, 800);
  },

  fadeOut: function fadeOut(element, options) {
    this.findById(element).fadeOut(options);
  },

  fadeIn: function fadeIn(element, options) {
    this.findById(element).fadeIn(options);
  },

  slideUp: function slideUp(elem, options) {
    options = options || {};

    if (options.remove) {
      var complete = options.complete;
      options.complete = function() {
        DOM.remove(elem);
        complete && complete();
      };
    }

    this.findById(elem).slideUp(options);
  },

  slideDown: function slideDown(element, options) {
    this.findById(element).slideDown(options);
  },

  setOpacity: function setOpacity(element, value) {
    return this.findById(element).css('opacity', value);
  }, 

  getOpacity: function getOpacity(element) {
    return this.findById(element).css('opacity');
  },

  contains: function contains(parentElement, targetElement) {
    parentElement = this.findById(parentElement);
    targetElement = this.findById(targetElement);
    return targetElement.closest(parentElement).length > 0;
  },

  replaceWithContent: function replaceWithContent(elem, content) {
    return this.replace(elem, this.fromContent(content));
  },

  prepend: function prepend(element, childElement) {
    element = this.findById(element);
    element.prepend(childElement);
    return element;
  },

  append: function append(element, childElement) {
    element = this.findById(element);
    element.append(childElement);
    return element;
  },

  replace: function replace(elem, newElement) {
    this.findById(elem).replaceWith(newElement);
    return newElement;
  },

  isEmpty: function isEmpty(element) {
    return this.findById(element).html().trim() == '';
  },

  // Show loading state only if response is slow enough.
  setLoadingIfNeeded: function setLoadingIfNeeded(element) {
    this.setAttribute(element, 'waitingforload', 1);
    var timeoutFunction = function() {
      if (!this.getAttribute(element, 'waitingforload')) {
        return;
      }
      // TODO(events): Do we need to check if element is still in DOM?
      this.setLoading(element, true);
    };
    setTimeout(FunctionUtils.bind(this, timeoutFunction), 500);
  },

  isLoading: function isLoading(element) {
    return this.hasClass(element, 'loading');
  },
  
  setLoading: function setLoading(element, isLoading) {
    this.removeAttribute(element, 'waitingforload');

    var loadingMode;
    if (this.isTextField(element)) {
      loadingMode = 'custom';
    } else {
      loadingMode = this.getAttribute(element, 'loadingMode');
      if (!loadingMode) {
        // For mobile. React won't pass through non-standard attributes without
        // the data- prefix. Camelcase is not allowed either, whatever.
        loadingMode = this.getAttribute(element, 'data-loadingmode');
      }
    }

    if (loadingMode !== 'custom') {
      var displayStyle = this.getStyle(element, 'display');
      if (displayStyle == 'block' || displayStyle == 'inline-block' || displayStyle == 'table-cell') {
        if (!this.getAttribute(element, 'loadingsetup')) {
          var loadingElement = Vendor.jQuery('<div class="elementLoadingIndicator layerDetail">&nbsp;</div>');
          this.findById(element)
          .css('position', 'relative')
          .prepend(loadingElement);
          this.setAttribute(element, 'loadingsetup', 1);
        }
      }
    }

    if (isLoading) {
      this.addClass(element, 'loading');
    } else {
      this.removeClass(element, 'loading');
    }
  },

  isCheckbox: function isCheckbox(element) {
    return (
      this.hasClass(element, 'UICheckbox')
      || this.isRegularCheckbox(element)
    );
  },
  
  isRegularCheckbox: function isRegularCheckbox(element) {
    return (
      this.tagName(element) === 'input'
      && this.getAttribute(element, 'type', '').toLowerCase() === 'checkbox'
    );
  },

  isCheckboxSelected: function isCheckboxSelected(checkbox) {
    if (this.hasClass(checkbox, 'UICheckbox')) {
      // Don't add dependency on UICheckboxController. This code is used in
      // mobile too.
      // return UICheckboxController.isSelected(checkbox);
      return this.hasClass(checkbox, 'selected');
    } else {
      return this.findById(checkbox).prop('checked');
    }
  },

  setCheckboxSelected: function setCheckboxSelected(checkbox, selected) {
    if (this.hasClass(checkbox, 'UICheckbox')) {
      UICheckboxController.setSelected(checkbox, selected);
    } else {
      this.findById(checkbox).prop('checked', selected);
    }
  },

  getPositionInWindow: function getPositionInWindow(element) {
    var position = this.positionInDocument(element);
    var scrollOffset = this.getPageScrollOffset();
    return {
      left: position.left,
      top: position.top - scrollOffset,
    };
  },

  positionInDocument: function positionInDocument(element) {
    return this.findById(element).offset();
  },

  positionInParent: function positionInParent(element) {
    return this.findById(element).position();
  },

  documentSize: function documentSize() {
    return {
      width: this.width(document),
      height: this.height(document)
    };
  },

  windowSize: function windowSize() {
    return {
      width: this.width(window),
      height: this.height(window)
    };
  },

  removeAllChildren: function removeAllChildren(elem) {
    return this.findById(elem).empty();
  },

  clone: function clone(elem) {
    return this.findById(elem).clone();
  },

  isInDOM: function isInDOM(elem) {
    if (!elem) {
      return false;
    }
    elem = this.findById(elem);
    return elem && Vendor.jQuery.contains(document.body, elem[0]);
  },

  remove: function remove(elem) {
    this.findById(elem).remove();
  },

  insertInDOM: function insertInDOM(elem) {
    return this.append(document.body, elem);
  },

  scrollToTop: function scrollToTop(animated) {
    return this.setPageScrollOffsetWithAnimation(0, animated);
  },

  scrollTo: function scrollTo(elem, options) {
    elem = this.findById(elem);

    options = options || {};
    var offset = options.offset || 0;
    var animated = options.animated;

    var container = this.findById('appPageContainer');
    if (container) {
      var headerContainer = this.findByClass(container, 'fixedHeaderContainer');
      offset -= this.height(headerContainer);
    } else {
      container = this.findById('pageBody');
    }

    offset += elem.offset().top - container.offset().top;
    // console.log('Setting scroll offset', offset, elem.offset(), container.offset(), container.scrollTop());
    return this.setPageScrollOffsetWithAnimation(offset, animated);
  },

  getScrollOffset: function getScrollOffset(container) {
    return this.findById(container).scrollTop();
  },

  setScrollOffset: function setScrollOffset(container, offset) {
    return this.findById(container).scrollTop(offset);
  },

  getPageScrollOffset: function getPageScrollOffset() {
    // Test in Firefox + IE before changing this
    return this.getScrollOffset(window);
  },

  setPageScrollOffset: function setPageScrollOffset(offset) {
    this.setPageScrollOffsetWithAnimation(offset, false);
  },

  setPageScrollOffsetWithAnimation: function setPageScrollOffsetWithAnimation(offset, animated, animationOptions) {
    this.enableDebug && Logger.log(this, 'Setting scroll offset', offset);
    // Just `body` or `pageBody` doesn't work in Firefox.
    // See http://stackoverflow.com/questions/18779708/scrolltop-with-animate-not-working
    if (animated) {
      var properties = {
        scrollTop: offset
      };
      Vendor.jQuery('body,html').animate(properties, animationOptions);
    } else {
      Vendor.jQuery('body,html').scrollTop(offset);
    }
  },

  makeScrollableWithMaxHeight: function makeScrollableWithMaxHeight(elem, maxHeight, options) {
    elem = this.findById(elem);

    if (this.hasClass(elem, 'scrollable')) {
      this.removeClass(elem, 'scrollable');
      elem.slimScroll({
        destroy: true
      });
      this.setStyle(elem, 'height', 'auto');
    }

    if (this.height(elem) <= maxHeight) {
      return;
    }

    var defaultOptions = {
      alwaysVisible: true,
      color: '#606472',
      opacity: 1,
      allowPageScroll: false,
      wheelStep: 10,
      height: maxHeight,
    };
    elem.slimScroll(ObjectUtils.extend(defaultOptions, options || {}));

    // Enabling scroll when mouse is already over the element will not activate
    // the scroll handler. Trigger a fake event. If the mouse is not over the
    // element, this doesn't cause any harm because scroll events are not sent
    // to this element
    elem.trigger('mouseenter');

    this.addClass(elem, 'scrollable');
  },

  getWidthForText: function getWidthForText(text) {
    var tempDivId = '__textSizeCalculator';
    var div = this.maybeFindById(tempDivId);
    if (!div) {
      div = this.createElement('div');
      this.setAttribute(div, 'id', tempDivId);
      div.css({
        position: 'absolute',
        visibility: 'hidden',
        top: '-100px'
      });
      this.append('pageBody', div);
    }
    div.html(text);
    var width = this.width(div);
    div.html('');
    return width;
  },

  _ATTR_TRANSFORMS: 'data-transforms',
  getTransforms: function getTransforms(elem) {
    var existingTransforms = this.getAttribute(elem, this._ATTR_TRANSFORMS) || '';
    if (!existingTransforms.length) {
      return {};
    }

    return ObjectUtils.fromJS(existingTransforms);
  },

  // Preserves existing transforms. CSS transform syntax is a mish-mash of
  // various propertys. Plus it's not clear how jquery translation from vanilla
  // property names works with vendor specific property names.
  setTransforms: function setTransforms(elem, transforms) {
    var allTransforms = {};

    var existingTransforms = this.getAttribute(elem, this._ATTR_TRANSFORMS) || '';
    if (existingTransforms.length) {
      allTransforms = ObjectUtils.fromJS(existingTransforms);
    }

    ObjectUtils.extend(allTransforms, transforms);

    var transformParts = [];
    ArrayUtils.each(allTransforms, function(propertyName, value) {
      var unit = '';
      if (propertyName == 'translateX' || propertyName == 'translateY') {
        unit = 'px';
      } else if (propertyName == 'rotate') {
        unit = 'deg';
      }
      transformParts.push(propertyName+'('+value+unit+')');
    });

    if (transformParts.length == 0) {
      return;
    }

    elem = this.findById(elem);
    elem.attr(this._ATTR_TRANSFORMS, ObjectUtils.toJS(allTransforms));
    elem.css('transform', transformParts.join(' '));
  },

  pageBody: function pageBody() {
    if (!this._pageBody) {
      this._pageBody = DOM.findBySelector('.pageBody');
    }
    return this._pageBody;
  },

  // TODO: Copied from AnalyticsLogger.web.js
  injectScript: function injectScript(url, options) {
    Assert.TRUTHY(url, 'Expected non-empty script url');

    options = options || {};

    const scriptElement = document.createElement('script');
    scriptElement.async = 1;
    scriptElement.defer = 1;
    scriptElement.src = url;
    scriptElement.onload = options.onload;

    const existingScriptElement = document.getElementsByTagName('script')[0];
    existingScriptElement.parentNode.insertBefore(scriptElement, existingScriptElement);
  },

});
